import { Component, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PremixCalculatorService } from '../../shared/services/calculator/premixcalculator.service';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-footer',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css']
})
export class FooterComponent implements OnInit, OnDestroy {
  footerHtml!: SafeHtml;
  isLegalContentVisible = false;

  private subscription?: Subscription;
  private retryCount = 0;
  private readonly maxRetries = 5;

  constructor(
    private calcultorService: PremixCalculatorService,
    private sanitizer: DomSanitizer
  ) {}

  ngOnInit(): void {
    this.loadFooterContent();
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }

  private loadFooterContent(): void {
    if (this.retryCount >= this.maxRetries) {
      console.error('Max retries exceeded for loading footer content');
      return;
    }

    const token = localStorage.getItem('APIKeyCMS');

    if (token) {
      this.subscription = this.calcultorService.getPremixLegalText().subscribe({
        next: (res: string) => {
          this.footerHtml = this.sanitizer.bypassSecurityTrustHtml(res);
          this.retryCount = 0;
        },
        error: (error) => {
          console.error('Failed to load footer content:', error);
          this.retryCount++;
          if ((error.status === 401 || error.status === 403) && this.retryCount < this.maxRetries) {
            const delay = Math.min(1000 * Math.pow(2, this.retryCount - 1), 5000);
            setTimeout(() => this.loadFooterContent(), delay);
          }
        }
      });
    } else {
      this.retryCount++;
      if (this.retryCount < this.maxRetries) {
        const delay = Math.min(500 * this.retryCount, 2000);
        setTimeout(() => this.loadFooterContent(), delay);
      }
    }
  }

  toggleLegalContent(): void {
    this.isLegalContentVisible = !this.isLegalContentVisible;
  }
}
